export default __webpack_public_path__ + "static/media/arrow-left.a89e4de1.svg";